//logos
import typescript from '../../assets/Experience logos/typescript logo.png';
import docker from '../../assets/Experience logos/docker logo.png';
import javascript from '../../assets/Experience logos/javascript logo.png';
import mongodb from '../../assets/Experience logos/mongodb logo.png';
import nextjs from '../../assets/Experience logos/nextjs logo.png';
import nodejs from '../../assets/Experience logos/nodejs.png';
import postgresql from '../../assets/Experience logos/postgresql logo.png';
import react from '../../assets/Experience logos/react logo.png';
import reactNative from '../../assets/Experience logos/react native logo.png';
import tailwind from '../../assets/Experience logos/tailwind logo.png';
import aws from '../../assets/Experience logos/aws.png';
import nest from '../../assets/Experience logos/nest.js-logo.png';
import jest from '../../assets/Experience logos/jest.png';

const technologies = [
  {
    id: 1,
    src: typescript,
    title: 'TYPESCRIPT',
    style: 'shadow-blue-500',
  },
  {
    id: 2,
    src: docker,
    title: 'DOCKER',
    style: 'shadow-cyan-500',
  },
  {
    id: 3,
    src: javascript,
    title: 'JAVASCRIPT',
    style: 'shadow-yellow-500',
  },
  {
    id: 4,
    src: mongodb,
    title: 'MONGODB',
    style: 'shadow-green-400',
  },
  {
    id: 5,
    src: nextjs,
    title: 'NEXT.JS',
    style: 'shadow-stone-500',
  },
  {
    id: 6,
    src: nodejs,
    title: 'NODE.JS',
    style: 'shadow-green-500',
  },
  {
    id: 7,
    src: postgresql,
    title: 'POSTGRESQL',
    style: 'shadow-cyan-500',
  },
  {
    id: 8,
    src: react,
    title: 'REACT',
    style: 'shadow-sky-500',
  },
  {
    id: 9,
    src: reactNative,
    title: 'REACT NATIVE',
    style: 'shadow-sky-500',
  },
  {
    id: 10,
    src: tailwind,
    title: 'TAILWIND',
    style: 'shadow-blue-500',
  },
  {
    id: 11,
    src: aws,
    title: 'AMAZON WEB SERVICES',
    style: 'shadow-orange-500',
  },
  {
    id: 12,
    src: nest,
    title: 'NEST.JS',
    style: 'shadow-red-500',
  },
  {
    id: 12,
    src: jest,
    title: 'JEST',
    style: 'shadow-red-500',
  },
];

export default technologies;
